<template>
  <b-list-group class="condensed">
    <!-- {{results}} -->
    <b-list-group-item class="py-2">
      <span class="detail-summary-tag" v-translate>Total bookings:</span><span class="detail-summary-info text-dark"> <b>{{summary.total}}</b> </span>
    </b-list-group-item>
    <b-list-group-item class="py-2">
      <span class="detail-summary-tag" v-translate>Total passengers:</span><span class="detail-summary-info text-info"><b>{{summary.pax}}</b> </span>
    </b-list-group-item>
    <b-list-group-item class="py-2">
      <span class="detail-summary-tag" v-translate>Total price:</span><span class="detail-summary-info text-primary"> <b>{{round(summary.price - summary.commission) }} {{currency}}</b></span>
    </b-list-group-item>
    <b-list-group-item class="py-2">
      <span class="detail-summary-tag" v-translate>Total paid:</span><span class="detail-summary-info text-success"> <b>{{round(summary.paid)}} {{currency}}</b> </span>
    </b-list-group-item>
    <b-list-group-item class="py-2">
      <span class="detail-summary-tag" v-translate>Rest payment :</span><span class="detail-summary-info text-danger"> <b>{{round(summary.price - summary.commission - summary.paid) }} {{currency}}</b> </span>
    </b-list-group-item>
  </b-list-group>
</template>

<script>
import { round } from '@/shared/utils'

export default {
  name: 'bookingSummary',
  props: ['results'],
  data () {
    return {
      currency: '',
      round: round
    }
  },
  created () {
    this.results.map(el => {
      this.currency = el.currency
    })
  },
  computed: {
    summary () {
      const summary = {
        total: this.results.length,
        pax: 0,
        price: 0,
        commission: 0,
        paid: 0
      }

      this.results.map(booking => {
        summary.pax += booking.pax
        summary.price += booking.gross + booking.tax
        summary.commission += booking.commission
        summary.paid += booking.paid_amount
      })

      const ret = {
        total: round(summary.total),
        pax: summary.pax,
        price: round(summary.price),
        commission: round(summary.commission),
        paid: round(summary.paid)
      }

      return ret
    }
  }
}
</script>
